import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import AIAnswerBlock from "./components/AIAnswerBlock";
import ProcessSection from "./components/ProcessSection";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreasSection from "./components/ServiceAreasSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import QuoteFormSection from "./components/QuoteFormSection";

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <TrustBar />
      <ServicesOverview />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreasSection />
      <TestimonialsSection />
      <FAQSection />
      <QuoteFormSection />
    </main>
  );
}
